<div>
    <div class="signin-wrapper justify-content-center align-items-center">
        <div class="card-signin mt-2">
            <h1 class="text-center mb-4 mmt-3" *ngIf="link != 'new'">{{'Reset Password'|translate}}</h1>
            <h1 class="text-center mb-4 mmt-3" *ngIf="link == 'new'">{{'Create Password'|translate}}</h1>
            <form [formGroup]="passwordForm" (ngSubmit)="passwordFun()">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <div class="form-group">
                            <label>{{'Activation Key'|translate}}</label>
                            <div class="input-icon">
                                <input type="text" class="form-control" id="activationCode"
                                    formControlName="activationCode" aria-describedby="emailHelp" required autofocus
                                    [ngClass]="{'is-invalid': submitted && f.activationCode.errors}">
                                <div class="invalid-feedback">{{'Usernamerequired'|translate}}</div>
                            </div>
                            <div *ngIf="submitted && f.activationCode.errors" class="invalid-feedback">
                                <div *ngIf="f.username.errors.required">{{'Usernamerequired'|translate}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12">
                        <div class="form-group">
                            <label for="enterPassword">{{'Password'|translate}}</label>
                            <div class="input-icon">
                                <input type="password" class="form-control" id="Password" required
                                    formControlName="newPassword" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }">
                                

                                <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                                    <div *ngIf="f.newPassword.errors.required">{{'Password is required'|translate}}</div>
                                    <div *ngIf="f.newPassword.errors.pattern">
                                        {{ 'Password must have at least 8 characters in length, 1 uppercase, lowercase, special character(@$!%*?&) and number' | translate }}
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12">
                        <div class="form-group">
                            <label for="enterPassword">{{'Confirm password'|translate}}</label>
                            <div class="input-icon">
                                <input type="password" class="form-control" id="confirmPassword" required
                                    formControlName="confirmPassword" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && (f.confirmPassword.errors || confirmPassword) }">
                                
                                <div *ngIf="submitted && (f.confirmPassword.errors || confirmPassword)"
                                    class="invalid-feedback">
                                    <div *ngIf="f.confirmPassword.errors  && f.confirmPassword.errors.required">
                                        {{'confirm password is required'|translate}}</div>
                                    <div *ngIf="confirmPassword">{{'confirm password does not match'|translate}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mt-4 text-center">
                        <div class="form-group">
                            <button mat-raised-button class="card-header-action mat-primary">
                                {{'Reset' | translate}}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>